import { render, staticRenderFns } from "./MetasDuplicates.vue?vue&type=template&id=5a139bdc&scoped=true"
import script from "./MetasDuplicates.vue?vue&type=script&lang=js"
export * from "./MetasDuplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a139bdc",
  null
  
)

export default component.exports